import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

const SensorChart = ({
  chartData,
  sensorNames,
  visibleLines,
  setVisibleLines,
}) => {
  return (
    <ResponsiveContainer width="100%" height={500}>
      <LineChart data={chartData}>
        <XAxis
          dataKey="date"
          tickFormatter={(date) =>
            dayjs(date).format('YYYY-MM-DD HH:mm') + 'hs'
          }
        />
        <YAxis tickFormatter={(value) => `${value}°C`} />
        <Tooltip
          formatter={(value) =>
            typeof value === 'number' ? `${value.toFixed(1)}°C` : value
          }
        />
        <Legend
          payload={sensorNames.map((name, index) => ({
            value: name,
            id: name,
            type: 'line',
            color: getColor(index),
            inactive: !visibleLines[name],
          }))}
          onClick={(e) => {
            const key = e.id;
            setVisibleLines((prev) => ({ ...prev, [key]: !prev[key] }));
          }}
        />
        {sensorNames.map(
          (name, index) =>
            visibleLines[name] && (
              <Line
                connectNulls
                key={name}
                type="monotone"
                dataKey={name}
                stroke={getColor(index)}
                strokeWidth={2}
                dot={false}
              />
            )
        )}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SensorChart;

function getColor(index) {
  const colors = [
    '#1976d2',
    '#ef6c00',
    '#2e7d32',
    '#d32f2f',
    '#512da8',
    '#0097a7',
    '#f9a825',
    '#6d4c41',
    '#c2185b',
    '#00796b',
  ];
  return colors[index % colors.length];
}
